import { useMediaQuery } from 'react-responsive';
import InfoBoxes from "./InfoBoxes";
import { motion } from 'framer-motion';
import Footer from './Footer';


const Home = ({isInIFrame}) => {

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1350px)'})

    return (  

        <div className="home-container">
            <motion.div className="backgroundDarkener"
                initial={{ opacity: 0 }} 
                animate={{ opacity: 1 }} 
                transition={{ delay: 1.1, duration: 0.8 }} 
            >
                <div className="container-info" style={{
                    height: isInIFrame ? '100vh' : '(calc(100vh - 58px))',
                    top: isInIFrame ? '0px' : '58px',
                }}>
                    {!isDesktopOrLaptop &&
                        <motion.h1 id="main-title"
                            initial={{ opacity: 0 }} 
                            animate={{ opacity: 1 }} 
                            transition={{ delay: 0.4, duration: 1.5 }} 
                            style={{
                                marginTop: isInIFrame ? '0px' : '50px',
                                paddingTop: isInIFrame ? '10px' : '0px' ,
                                paddingBottom: isInIFrame ? '13px' : '0px',
                                marginBottom: isInIFrame ? '-20px' : '0px'

                            }}
                        >
                            קלסר קליטה ומידע לתושבי שדה נחמיה
                        </motion.h1>
                    }

                    {isDesktopOrLaptop &&
                        <motion.h1 id="main-title"
                            initial={{ opacity: 0 }} 
                            animate={{ opacity: 1 }} 
                            transition={{ delay: 1, duration: 1.5 }} 
                            style={{
                                marginTop: isInIFrame ? '0px' : '10px',
                                top: isInIFrame ? '0px' : '10px',
                                paddingBottom: isInIFrame ? '13px' : '10px'
                            }}
                        >
                            קלסר קליטה ומידע לתושבי שדה נחמיה
                        </motion.h1>
                    }
                    <InfoBoxes isInIFrame={isInIFrame}/>  
                </div>
            </motion.div>

            {(isDesktopOrLaptop && !isInIFrame) &&
            <Footer />
            }

        </div>
    )

}
 
export default Home;


